import { useQuery } from '@tanstack/react-query';

import { createQuizResultsStore } from '../useQuizResultStore';

import { sdk } from '@/services';

const QuizResultService = sdk.getService('QuizResultService');
const useStore = createQuizResultsStore({ courseName: 'asc' });

export const useMyQuizResultsByCourseWithFilters = () => {
  const { sort, setSort, filters, setFilters } = useStore();

  const queryKey = ['quiz-results', 'by-course', sort, filters];

  const { data, isLoading } = useQuery({
    queryKey,
    queryFn: () => QuizResultService.findUserQuizStatsByCourseAndFilters(filters, sort)
  });

  return {
    quizResultsByCourse: data ?? [],
    isLoading,
    sort,
    setSort,
    filters,
    setFilters
  };
};
